import { weeks, epoch, claimingPeriod, pickerPct, fromWei, getTimestamp, round } from "./constants";

const Winners = ({ enabled, history, walletAddress, symbol, amountPerBet, explorerAddressUrl, 
  genesisTimestamp, onPickWinnerPressed, onClaimPrizePressed }) => (

  <section className="winners">
    <h2>Previous winners</h2>
    <p>Click on "Pick winner" 10 minutes after the end of the lottery to pick the winner. You will get 5% of the total 
      amount of bets if you pick the winner first.</p>
    <p>Click on "Claim prize" to claim your prize. The button is visible only if your are the Lottery winner and if your wallet is connected. Winners can claim their prize only within 90 days, after this period the prize is lost.</p>
      { Object.entries(history).reverse().map(([key, weekData]) => {
        let returnButton;          
        if (!enabled || walletAddress.length === 0) {
          returnButton = (<button className="deactivated">Pick winner</button>)
        } else {
          if (String(weekData.winner).toLowerCase() === String(walletAddress).toLowerCase()) {
            if ((!weekData.prizeClaimed)
                && (getTimestamp() < Number(genesisTimestamp) + (Number(weekData.weekNumber) + 1) * weeks + claimingPeriod + epoch)) {

                returnButton = (
                  <button onClick={(event) => {
                    onClaimPrizePressed(event.target.value)
                    }} value={weekData.weekNumber}>Claim Prize</button>
                )

            } else {
              returnButton = (<button className="deactivated">Claim Prize</button>)
            }

          } else if (
            (weekData.winner === '0x0000000000000000000000000000000000000000') 
            // && (getTimestamp() > Number(genesisTimestamp) + (Number(weekData.weekNumber) + 1) * weeks + waitingTime + epoch)
            && (getTimestamp() > Number(genesisTimestamp) + (Number(weekData.weekNumber) + 1) * weeks + epoch)
            && (getTimestamp() < Number(genesisTimestamp) + (Number(weekData.weekNumber) + 1) * weeks + claimingPeriod + epoch)
            && (Number(weekData.nbPlayers) > 0)
          ) {

            returnButton = (
              <button onClick={(event) => {
                onPickWinnerPressed(event.target.value)
              }} value={weekData.weekNumber}>Pick winner</button>
            )

          } else {
            returnButton = (<button className="deactivated">Pick winner</button>)
          }
        }

        return(
          <div className="block" key={key}>
            <h4>Lottery #{weekData.weekNumber} - {weekData.nbPlayers} bets</h4>
            <div className="content">
              <div className="wrap">
                <div className="row">
                  <div className="left">Winner:&nbsp; 
                  { (weekData.winner !== '0x0000000000000000000000000000000000000000')
                      ? (<a target="_blank" rel="noreferrer" href={`${explorerAddressUrl}${weekData.winner}`}>{weekData.winner}</a>)
                      : (<span>undefined winner&nbsp;</span>)
                  }
                  </div>
                  <div>💰 {round(fromWei(weekData.amount), 5)} {symbol}</div>
                </div>
                <div className="row">
                  <div className="left">Picker:&nbsp;
                  { (weekData.picker !== '0x0000000000000000000000000000000000000000')
                      ? (<a target="_blank" rel="noreferrer" href={`${explorerAddressUrl}${weekData.picker}`}>{weekData.picker}</a>)
                      : (<span>undefined picker&nbsp;</span>)
                  }
                  </div>
                  <div>🎁 {round((weekData.nbPlayers*amountPerBet*pickerPct)/100, 5)} {symbol}</div>
                </div>
              </div>
              {returnButton}
            </div>
          </div>
        )
      })
    }
  </section>
)

export default Winners